import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { forwardRef } from 'react';
// @mui
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

const Page = forwardRef(({ children, title = '', sx = {}, meta, ...other }, ref) => (
  <>
    <Helmet>
            <title>{`tiketic | ${title}`}</title>
      {meta}
    </Helmet>

        <Box ref={ref} {...other} sx={{
            backgroundColor: '#F9FAFB',
            ...sx,   // merge user-defined styles
        }}>
      {children}
    </Box>
  </>
));

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  meta: PropTypes.node,
};

export default Page;
